/**
 * The module each guide group is about (ADR-0100). While that module is off,
 * the group's guides leave every listing. Player AI, Using the app and Admin
 * Console belong to no module and always show; KPI Manager has no group.
 * Exhaustive by type, so a new group must say which module it belongs to.
 */
const DOMAIN_MODULES = {
    solve: "solve",
    vsm: "vsm",
    hoshin: "hoshin",
    lama: "lama",
    "player-ai": null,
    platform: null,
    admin: null,
};
/** `domainId` may be any URL segment, so only the map's own keys count. */
export function moduleForKnowledgeDomain(domainId) {
    return domainId !== undefined && Object.hasOwn(DOMAIN_MODULES, domainId)
        ? DOMAIN_MODULES[domainId]
        : null;
}
//# sourceMappingURL=domain-modules.js.map